import axios from "axios";

export default class Util {
  static removerCaracteresEspeciais(entrada: string) {
    try {
      let retorno = entrada.toString().replace(/\./g, "");
      retorno = retorno.toString().replace(/\-/g, "");
      retorno = retorno.toString().replace(' ', '');
      retorno = retorno.toString().replace('(', '');
      retorno = retorno.toString().replace(')', '');
      retorno = retorno.toString().replace(' ', '');
      retorno = retorno.toString().replace('(', '');
      retorno = retorno.toString().replace(')', '');
      retorno = retorno.toString().replace(' ', '');
      retorno = retorno.toString().replace('(', '');
      retorno = retorno.toString().replace(')', '');
      retorno = retorno.toString().replace(' ', '');
      retorno = retorno.toString().replace('(', '');
      retorno = retorno.toString().replace(')', '');
      return retorno.toString().replace(/\_/g, "");
    } catch (e: any) {
      console.log(e?.message);
    }
  }

  static removeAcentos(entrada: string) {
    let com_acento =
      "ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖØÙÚÛÜÝŔÞßàáâãäåæçèéêëìíîïðñòóôõöøùúûüýþÿŕ";
    let sem_acento =
      "AAAAAAACEEEEIIIIDNOOOOOOUUUUYRsBaaaaaaaceeeeiiiionoooooouuuuybyr";
    let novastr = "";

    for (let i = 0; i < entrada.length; i++) {
      let troca = false;
      for (let a = 0; a < com_acento.length; a++) {
        if (entrada.substr(i, 1) == com_acento.substr(a, 1)) {
          novastr += sem_acento.substr(a, 1);
          troca = true;
          break;
        }
      }
      if (troca == false) {
        novastr += entrada.substr(i, 1);
      }
    }

    return novastr;
  }

  static calculatePagesCount = (pageSize: number, totalCount: number) => {
    return totalCount < pageSize ? 1 : Math.ceil(totalCount / pageSize);
  };

  static inverterString(entrada: string) {
    return entrada.split("").reverse();
  }

  public static async delay(time: number) {
    return new Promise((resolve) => setTimeout(resolve, time));
  }

  public static async getFileURLHttp(
    url: string,
    /** @defaultValue 80 */ port: number = 80
  ) {
    const file = await axios
      .get(url, {
        responseType: "arraybuffer",
      })
      .then((res) => {
        return Buffer.from(res.data).toString("base64");
      })
      .catch((err) => {
        console.log(err);
        return "error";
      });

    return file;
  }

  static addAlgarisms(valor: string, tamanho: number) {
    let valorNovo = valor;

    for (; valorNovo.length < tamanho; valorNovo = `0${valorNovo}`) {}

    return valorNovo;
  }

  static testNumbers(
    valorNovo: number | undefined | null,
    valorAtual: number | undefined
  ) {
    if (valorNovo == undefined || valorNovo == null) {
      return valorAtual;
    }
    return valorNovo;
  }

  static completarZerosEsquerda(str: string, length: number) {
    const resto = length - str.length;
    return "0".repeat(resto > 0 ? resto : 0) + str;
  }

  static testStrings(
    valorNovo: string | undefined | null,
    valorAtual: string | undefined
  ) {
    if (valorNovo == undefined || valorNovo == null) {
      return valorAtual;
    }
    return valorNovo;
  }

  static tipoMovimentacao(tipo: string) {
    switch (tipo) {
      case "S":
        return "Saidas";
      case "P":
        return "Pedidos";
      case "R":
        return "Reservas";
      default:
        return "Acerto";
    }
  }
}
